import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '@/store';

export const value = (state: RootState) => state.layout;
export const visual = createSelector(value, (v) => v.visual);
export const wasOpened = createSelector(value, (v) => v.wasOpened);
export const isMinimized = createSelector(visual, (v) => v === 'minimized');
export const isVisible = createSelector(visual, (v) => v === 'visible');
